import React from 'react';
import { Link } from 'react-router-dom';

export const CargosScreen = () => {

    return (
        <>
            <div id="titlebar">
                <div className="container">
                    <div className="sixteen columns">
                        <h2>Cargos más buscados</h2>
                        <span>Contamos con un importante catálogo de cargos donde somos especialistas, a continuación se muestran los más buscados al día de hoy</span>
                    </div>
                </div>
            </div>

            <div id="categories">
                <div className="categories-group">
                    <div className="container">
                        <div className="four columns">
                            <h4><i className="ln ln-icon-Worker"></i> <br />Logística</h4>
                        </div>
                        <div className="twelve columns">
                            <ul>
                                <li><Link to="/oportunidades?q=bandejas">Operarios(as) Lavado de Bandejas San Bernardo</Link></li>
                                <li><Link to="/oportunidades?q=Operario">Operario(A) de Bodega San Bernardo Turno Tarde</Link></li>
                                <li><Link to="/oportunidades?q=Apilador">Apilador Eléctrico Doble Pantógrafo Noviciado</Link></li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="categories-group">
                    <div className="container">
                        <div className="four columns">
                            <h4><i className="ln ln-icon-Computer"></i> <br />Web, Software y TI</h4>
                        </div>
                        <div className="twelve columns">
                            <ul>
                                <li><Link to="/oportunidades?q=Operador Networking">Operador Networking Router Switch, Cisco, Firewall</Link></li>
                                <li><Link to="/oportunidades?q=Programador">Desarrolladores, Analistas, Programadores</Link></li>

                            </ul>
                        </div>
                    </div>
                </div>

                <div className="categories-group">
                    <div className="container">
                        <div className="four columns">
                            <h4><i className="ln ln-icon-Management"></i> <br />Servicios Financieros</h4>
                        </div>
                        <div className="twelve columns">
                            <ul>
                                <li><Link to="/oportunidades?q=ATENCION CLIENTE">Atencion Cliente Bancario. Nivel Nacional</Link></li>
                                <li><Link to="/oportunidades?q=EJECUTIVO CALL CENTER">Ejecutivo Call Center Bancario</Link></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="categories-group">
                    <div className="container">
                        <div className="four columns">
                            <h4><i className="ln ln-icon-Administrator"></i> <br />Administrativos</h4>
                        </div>
                        <div className="twelve columns">
                            <ul>
                                <li><Link to="/oportunidades?q=ejecutivo">EJECUTIVOS/AS CONVENIOS SEGUROS</Link></li>
                                <li><Link to="/oportunidades?q=contable">Administrativo Contable Providencia</Link></li>

                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div className="categories-group">
                <div className="container">
                    <div className="four columns">
                        <h4><i className="ln ln-icon-Worker-Clothes"></i> <br />Minería</h4>
                    </div>
                    <div className="twelve columns">
                        <ul>
                            <li><Link to="/oportunidades?q=pmo">INGENIERO PMO SANTIAGO</Link></li>
                            <li><Link to="/oportunidades?q=BODEGUERO">BODEGUERO SANTIAGO</Link></li>
                            <li><Link to="/oportunidades?q=ADMINISTRATIVO DE RECURSOS HUMANOS">ADMINISTRATIVO DE RECURSOS HUMANOS</Link></li>
                        </ul>
                    </div>
                </div>
            </div>

            <div className="categories-group">
                <div className="container">
                    <div className="four columns">
                        <h4><i className="ln ln-icon-Nurse"></i> <br />Salud</h4>
                    </div>

                    <div className="four columns">
                        <ul>
                            <li><Link to="/oportunidades?q=Técnico">Técnico Laboratorio Clínico</Link></li>
                            <li><Link to="/oportunidades?q=Cajeros">Cajeros/as Full y Part time</Link></li>
                            <li><Link to="/oportunidades?q=Asistente Dental">Asistente Dental</Link></li>
                        </ul>
                    </div>
                    <div className="four columns">
                        <ul>
                            <li><Link to="/oportunidades?q=Cuidador de Pacientes">Cuidador de Pacientes</Link></li>
                            <li><Link to="/oportunidades?q=Técnicos en enfermería">Técnicos en enfermería</Link></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="categories-group">
                <div className="container">
                    <div className="four columns">
                        <h4><i className="ln ln-icon-Eyebrow-3"></i> <br />Pausa Activa</h4>
                    </div>
                    <div className="twelve columns">
                        <ul>
                            <li><Link to="/oportunidades?q=Profesor">Profesores/as educación física - Centro Integral</Link></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="categories-group">
                <div className="container">
                    <div className="four columns">
                        <h4><i className="ln ln-icon-Drop"></i> <br />Higiene</h4>
                    </div>
                    <div className="twelve columns">
                        <ul>
                            <li><Link to="/oportunidades?q=Aseo">Auxiliares de Aseo</Link></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="categories-group">
                <div className="container">
                    <div className="four columns">
                        <h4><i className="ln ln-icon-Diamond"></i> <br />Seguridad</h4>
                    </div>
                    <div className="twelve columns">
                        <ul>
                            <li><Link to="/oportunidades?q=Guardia">Guardias de Seguridad 4X4 Volantes</Link></li>
                            <li><Link to="/oportunidades?q=Guardia">Guardias de Seguridad 4X4 - Recoleta</Link></li>
                        </ul>
                    </div>
                </div>
            </div>
        </>
    )
}
